var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { goBack, navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { loadDelegatees, loadDelegators, loadPendingOutgoingUndelegations, } from '@popup/steem/actions/delegations.actions';
import { DelegationType } from '@popup/steem/pages/app-container/home/delegations/delegation-type.enum';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { DelegationUtils } from '@popup/steem/utils/delegation.utils';
import { KeychainKeyTypes } from '@steempro/steem-keychain-commons';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { Screen } from 'src/reference-data/screen.enum';
import FormatUtils from 'src/utils/format.utils';
const IncomingOutgoing = ({ activeAccount, delegationType, username, amount, globalProperties, currencyLabels, expirationDate, navigateToWithParams, setErrorMessage, setSuccessMessage, addToLoadingList, removeFromLoadingList, loadDelegatees, loadDelegators, loadPendingOutgoingUndelegations, goBack, }) => {
    const [editModeActivated, setEditModeActivated] = useState(false);
    const [value, setValue] = useState('');
    const [amountHP, setAmountHP] = useState('...');
    const [isExpanded, setIsExpanded] = useState(false);
    useEffect(() => {
        setAmountHP(FormatUtils.toSP(amount.toString().replace(' VESTS', ''), globalProperties).toFixed(3));
    }, [amount]);
    const toggleExpandablePanel = () => {
        if (!editModeActivated)
            setIsExpanded(!isExpanded);
    };
    const cancelDelegation = () => __awaiter(void 0, void 0, void 0, function* () {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_cancel_delegation_message'),
            title: 'popup_html_cancel_delegation',
            fields: [{ label: 'popup_html_transfer_to', value: `@${username}` }],
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_cancel_delegation_operation');
                try {
                    let success = yield DelegationUtils.delegateVestingShares(activeAccount.name, username, '0.000000 VESTS', activeAccount.keys.active, options);
                    if (success) {
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else
                            setSuccessMessage('popup_html_cancel_delegation_successful');
                        yield refreshDelegations();
                        goBack();
                    }
                    else {
                        setErrorMessage('popup_html_cancel_delegation_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_cancel_delegation_operation');
                }
            }),
        });
    });
    const enterEditMode = () => {
        setEditModeActivated(true);
        setValue(amountHP);
    };
    const cancelEdit = () => {
        setEditModeActivated(false);
        setValue(amountHP);
    };
    const saveChanges = () => __awaiter(void 0, void 0, void 0, function* () {
        setEditModeActivated(false);
        setAmountHP(value);
        if (Number(value) <= 0) {
            cancelDelegation();
        }
        const formattedAmount = `${parseFloat(value.toString()).toFixed(3)} ${currencyLabels.sp}`;
        const stringifiedAmount = `${FormatUtils.formatCurrencyValue(parseFloat(value.toString()))} ${currencyLabels.sp}`;
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_delegation', [
                value,
                `@${username}`,
            ]),
            title: 'popup_html_delegation',
            fields: [
                { label: 'popup_html_transfer_to', value: `@${username}` },
                { label: 'popup_html_value', value: stringifiedAmount },
            ],
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_delegation_operation');
                try {
                    let success = yield DelegationUtils.delegateVestingShares(activeAccount.name, username, FormatUtils.fromSP(value.toString(), globalProperties).toFixed(6) +
                        ' VESTS', activeAccount.keys.active, options);
                    if (success) {
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else
                            setSuccessMessage('popup_html_delegation_successful');
                        yield refreshDelegations();
                        goBack();
                    }
                    else {
                        setErrorMessage('popup_html_delegation_fail');
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_delegation_operation');
                }
            }),
        });
    });
    const refreshDelegations = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield new Promise((resolve, reject) => {
            setTimeout(() => {
                loadDelegators(activeAccount.name);
                loadDelegatees(activeAccount.name);
                loadPendingOutgoingUndelegations(activeAccount.name);
                resolve();
            }, 3000);
        });
    });
    return (React.createElement("div", { className: "delegation-row", key: username },
        username && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "item", onClick: toggleExpandablePanel },
                React.createElement("div", { className: "username" }, `@${username}`),
                React.createElement("div", { className: "item-details" },
                    !editModeActivated && (React.createElement("div", { className: "value", onDoubleClick: () => {
                            if (delegationType === DelegationType.OUTGOING)
                                enterEditMode();
                        } },
                        FormatUtils.withCommas(amountHP),
                        " ",
                        currencyLabels.sp)),
                    editModeActivated && (React.createElement("div", { className: "edit-panel" },
                        React.createElement("input", { className: "edit-label", value: value, onChange: (e) => setValue(e.target.value), placeholder: getMessage('popup_html_favorite_user_nickname') }),
                        React.createElement(SVGIcon, { onClick: () => saveChanges(), icon: SVGIcons.FAVORITE_ACCOUNTS_SAVE, className: "edit-button" }),
                        React.createElement(SVGIcon, { onClick: () => cancelEdit(), icon: SVGIcons.FAVORITE_ACCOUNTS_CANCEL, className: "edit-button" }))),
                    delegationType !== DelegationType.INCOMING && (React.createElement(SVGIcon, { icon: SVGIcons.WALLET_HISTORY_EXPAND_COLLAPSE, className: `expand-collapse-icon ${isExpanded ? 'open' : 'closed'}`, onClick: toggleExpandablePanel })))),
            isExpanded && (React.createElement("div", { className: "expanded-panel" }, !editModeActivated && (React.createElement(React.Fragment, null,
                React.createElement(Separator, { type: "horizontal" }),
                React.createElement("div", { className: "expandable-panel-content" },
                    React.createElement("div", { className: "delegation-item-button edit", onClick: () => enterEditMode() },
                        React.createElement(SVGIcon, { icon: SVGIcons.FAVORITE_ACCOUNTS_EDIT }),
                        React.createElement("span", { className: "label" }, getMessage('html_popup_button_edit_label'))),
                    React.createElement("div", { className: "delegation-item-button delete", onClick: () => cancelDelegation() },
                        React.createElement(SVGIcon, { icon: SVGIcons.FAVORITE_ACCOUNTS_DELETE }),
                        React.createElement("span", { className: "label" }, getMessage('delete_label')))))))))),
        expirationDate && (React.createElement("div", { className: "pending-undelegation" },
            React.createElement("div", { className: "expiration-date" }, moment(expirationDate).format('L')),
            React.createElement("div", { className: "amount" },
                amountHP,
                " ",
                currencyLabels.sp)))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        activeAccount: state.steem.activeAccount,
        globalProperties: state.steem.globalProperties.globals,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setErrorMessage,
    setSuccessMessage,
    addToLoadingList,
    removeFromLoadingList,
    loadDelegatees,
    loadDelegators,
    loadPendingOutgoingUndelegations,
    goBack,
});
export const IncomingOutgoingItemComponent = connector(IncomingOutgoing);
